<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <language-dialog :dialog-visible='!hasLanguage'></language-dialog>
  </div>
</template>

<script>
import LanguageDialog from '@/components/LanguageDialog.vue';
import { mapState } from 'vuex';

export default {
  name: "app",
  components: {
    LanguageDialog,
  },
  watch: {
    '$route': function(route) {
      if(!['login', null].includes(this.$route.name)) {
        this.checkLanguage();
      } else {
        this.hasLanguage = true
      }
    }
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      hasLanguage: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    checkLanguage(){
      this.$Service.fetch({
        url: 'checkCurrLanguage'
      }).then(res => {
        if(res.code == '1') {
          this.hasLanguage = !res.data
        }
      })
    }
  }
};
</script>

<style lang="less">
#app {
  font-family: SourceHanSansSC-Medium, SourceHanSansSC, Avenir, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //   text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.el-popover {
  max-width: 50%;
}
</style>
